import { parseQueryState, removeFalsy } from '#component/project/project-log/helper';

export const isUser = id => id.toString().includes('user');
export const isDevice = id => id.toString().includes('device');
export const getUserDeviceID = id => +(id.split('_')[1]);

/**
 * Build search params
 * @param {string} params - current search params.
 * @param {Array|Object} newParams - new search params.
 * @returns {string} - merged search params
 */

export const getSearchParams = (params, newParams) => {
  let searchParams;

  if (!newParams) {
    return '';
  }

  if (Array.isArray(newParams)) {
    const parsedCurrUrl = parseQueryState(params);
    searchParams = new URLSearchParams({
      ...parsedCurrUrl,
      ...{
        project: '',
        user: '',
        device: ''
      }
    });
    const param = {
      project: [],
      user: [],
      device: [],
      page: [],
      order: [],
      orderBy: []
    };
    newParams.forEach(el => {
      const { type, value } = el;
      const lowerCaseType = type.toLowerCase();
      if (searchParams.has(lowerCaseType)) {
        param[lowerCaseType].push(value);
        searchParams.set(lowerCaseType, `${param[lowerCaseType].join(',')}`);
      } else {
        searchParams.set(lowerCaseType, value);
      }
    });
  } else {
    searchParams = new URLSearchParams(params);
    const { filterType, value, end, start } = newParams;

    if (filterType && value) {
      searchParams.set(filterType, value);
    }
    if (start && end) {
      searchParams.set('start', start);
      searchParams.set('end', end);
    }
  }

  const currentUrl = parseQueryState(params);
  const newUrl = parseQueryState(searchParams.toString());
  const mergedUrls = { ...currentUrl, ...newUrl };
  const url = new URLSearchParams(removeFalsy(mergedUrls));

  return `${url.toString()}`;
};

export const getProjectsIds = (source, key) => {
  const result = source.value.reduce((acc, cur) => {
    const filteredOptionProjects = cur.data?.[key] || [];

    return [...acc, ...filteredOptionProjects];
  }, []);

  return result;
};
